const createTheme = theme => theme;
export { createTheme };
//# sourceMappingURL=createTheme.mjs.map
